export default __webpack_public_path__ + "static/media/Service_pic5.b8f3960b.png";